/**
 * @file Reads the dir attribute from the html object to detect the direction.
 */
const dir = document.documentElement.dir || document.documentElement.attributes['data-dir']?.value || 'ltr'

export { dir }
